export function Skeleton() {
  return (
    <div className="animate-pulse space-y-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-6 shadow-sm dark:border-slate-700 dark:bg-slate-900">
      <div className="h-4 w-1/3 rounded bg-slate-200 dark:bg-slate-700" />
      <div className="h-4 w-2/3 rounded bg-slate-100 dark:bg-slate-800" />
      <div className="h-4 w-1/2 rounded bg-slate-100 dark:bg-slate-800" />
    </div>
  );
}
